<page-data-manager>
  <form ng-submit="del.submit()" name="deleteConfig" class="ibox">
    <div class="ibox-title">
      <h2>Apagar dados {{currentPropriedade.descricao}}</h2>
    </div>
    <div class="ibox-content">
      <div class="form-horizontal">
        <!-- Tipos de dados -->
        <div class="form-group">
          <div class="col-xs-3 text-right">
            <label class="control-label">Tipos de dados</label>
          </div>
          <div class="col-xs-9">
            <div class="checkbox" ng-repeat="type in del.availableTypes track by type.value">
              <label>
                <input type="checkbox"
                        name="selectedTypes[]"
                        ng-value="type.value"
                        ng-checked="del.selectedTypes.includes(type.value)"
                        ng-click="del.toggleSelectedType(type.value)">
                {{type.label}}
              </label>
            </div>
          </div>
        </div>
        <div class="hr-line-dashed"></div>

        <!-- Seletor tipos de datas -->
        <div class="form-group">
          <label class="control-label col-xs-3">Data (s)</label>
          <div class="col-xs-9">
            <div class="btn-group">
              <label class="btn btn-primary" ng-model="del.dateType" uib-btn-radio="'single'">Dia único</label>
              <label class="btn btn-primary" ng-model="del.dateType" uib-btn-radio="'bulk'">Vários dias</label>
              <label class="btn btn-primary" ng-model="del.dateType" uib-btn-radio="'interval'">Intervalo</label>
            </div>
            <p class="help-block" ng-if="del.dateType === 'interval'">
              <b>Obs:</b>
              Intervalos são inclusivos, ou seja, os registros das datas inicial e final também serão apagados.
            </p>
          </div>
        </div>

        <!-- Datas: dia único -->
        <div class="form-group" ng-if="del.dateType === 'single'">
          <div class="col-xs-9 col-xs-push-3">
            <div class="input-group">
              <input type="text" class="form-control" readonly datepicker-options="del.datepickerOptions"
                uib-datepicker-popup="{{del.calendarConfig.format}}" ng-model="del.singleDate" required
                is-open="del.calendarConfig.singleOpen" show-button-bar="false" name="singleDate">
              <span class="input-group-btn">
                <button type="button" class="btn btn-default" ng-click="del.calendarConfig.singleOpen = true">
                  <i class="glyphicon glyphicon-calendar"></i>
                </button>
              </span>
            </div>
          </div>
        </div>

        <!-- Datas: múltiplos dias -->
        <div class="form-group" ng-if="del.dateType === 'bulk'">
          <div class="col-xs-9 col-xs-push-3">
            <div class="input-group">
              <input type="text" class="form-control" readonly datepicker-options="del.datepickerOptions"
                uib-datepicker-popup="{{del.calendarConfig.format}}" ng-model="del.multipleTemp"
                is-open="del.calendarConfig.singleOpen" show-button-bar="false" ng-change="del.addDate()"
                placeholder="Adicionar data">
              <span class="input-group-btn">
                <button type="button" class="btn btn-default" ng-click="del.openMultiple()">
                  <i class="glyphicon glyphicon-calendar"></i>
                </button>
              </span>
            </div>
            <table class="table table-condensed table-hover">
              <tbody>
                <tr ng-repeat="date in del.multipleDates track by $index">
                  <td>{{date | date:'dd/MM/yyyy'}}</td>
                  <td class="text-right">
                    <button class="btn btn-danger btn-xs" ng-click="del.removeDate(date)">
                      <i class="fa fa-trash"></i>
                    </button>
                  </td>
                </tr>
              </tbody>
            </table>
          </div>
        </div>

        <!-- Datas: intervalo -->
        <div ng-if="del.dateType === 'interval'">
          <div class="form-group">
            <label class="control-label col-xs-3">De:</label>
            <div class="col-xs-9">
              <div class="input-group">
                <input type="text" class="form-control" readonly datepicker-options="del.datepickerOptions"
                  uib-datepicker-popup="{{del.calendarConfig.format}}" ng-model="del.interval.start"
                  is-open="del.calendarConfig.startOpen" show-button-bar="false" name="startDate" required>
                <span class="input-group-btn">
                  <button type="button" class="btn btn-default" ng-click="del.calendarConfig.startOpen = true">
                    <i class="glyphicon glyphicon-calendar"></i>
                  </button>
                </span>
              </div>
            </div>
          </div>
          <div class="form-group" ng-class="{'has-error': del.isIntervalEndBeforeStart()}">
            <label class="control-label col-xs-3">Até:</label>
            <div class="col-xs-9">
              <div class="input-group">
                <input type="text" class="form-control" readonly datepicker-options="del.datepickerOptions"
                  uib-datepicker-popup="{{del.calendarConfig.format}}" ng-model="del.interval.end"
                  is-open="del.calendarConfig.endOpen" show-button-bar="false" name="endDate" required>
                <span class="input-group-btn">
                  <button type="button" class="btn btn-default" ng-click="del.calendarConfig.endOpen = true">
                    <i class="glyphicon glyphicon-calendar"></i>
                  </button>
                </span>
              </div>
            </div>
          </div>
        </div>

        <div class="hr-line-dashed"></div>

        <div class="form-group has-error">
          <div class="col-xs-9 col-xs-push-3">
            <div class="checkbox">
              <label>
                <input type="checkbox" name="confirmation" ng-model="del.confirmation" required>
                Confirmo que os dados acima estão corretos e estou ciente que estas ações <b>não podem ser desfeitas</b>
              </label>
            </div>
          </div>
        </div>

        <div class="hr-line-dashed"></div>

        <div class="form-group">
          <div class="col-xs-9 col-xs-push-3">
            <button type="submit" class="btn btn-danger" ng-disabled="del.isDisabled(deleteConfig.$invalid)">
              Apagar dados
              <i class="fa fa-trash"></i>
            </button>
          </div>
        </div>

      </div>
    </div>
  </form>
</page-data-manager>
